import React from "react";
import { Route, Routes } from "react-router-dom";
import MinorLayout from "../components/layouts/minor-layout";
import MinorHome from "../containers/minor/minor-home";
import MinorExperiences from "../containers/minor/minor-experiences";
import DigitalPassport from "../containers/minor/digital-passports";
import FavoriteHost from "../containers/minor/favorite-host";
import MinorGeneralSettings from "../containers/minor/general-setting";
import MinorEditProfile from "../containers/minor/edit-profile";
import MinorExperiencesDetail from "../containers/minor/experience-detail";
import MinorRatings from "../containers/minor/ratings";
import EventPass from "../containers/minor/event-pass";
import HostProfileDetailMinor from "../containers/minor/host-profile-details";


const MinorRoutes = () => {
  return (
    <MinorLayout>
      <Routes>
        <Route path="/home" element={<MinorHome />} />
        <Route path="/experiences" element={<MinorExperiences />} />
        <Route path="/digital-passport" element={<DigitalPassport />} />
        <Route path="/favorite-host" element={<FavoriteHost />} />
        <Route path="/general-setting" element={<MinorGeneralSettings />} />
        <Route path="/edit-profile" element={<MinorEditProfile />} />
        <Route path="/experience-detail" element={<MinorExperiencesDetail />} />
        <Route path="/ratings" element={<MinorRatings />} />
        <Route path="/ticket" element={<EventPass />} />
        <Route path="/profile-detail-host" element={<HostProfileDetailMinor />} />        
      </Routes>
    </MinorLayout>
  );
};

export default MinorRoutes;
